import { BoxGeometry, CylinderGeometry, Group, Mesh } from 'three';
import { RescueTool } from './RescueTool';

export class LifeVest extends RescueTool {
  constructor() {
    super('lifeVest');
    const vest = new Group();
    for (const x of [-0.5, 0.5]) {
      const pad = new Mesh(new BoxGeometry(0.72, 1.5, 0.35), this.standardMaterial(0xff8f3d));
      pad.position.x = x;
      pad.castShadow = true;
      vest.add(pad);
    }
    const belt = new Mesh(new BoxGeometry(1.55, 0.18, 0.45), this.standardMaterial(0x3b4856));
    belt.position.y = -0.45;
    vest.add(belt);
    const buckle = new Mesh(new CylinderGeometry(0.13, 0.13, 0.28, 8), this.standardMaterial(0xffc83d));
    buckle.rotation.z = Math.PI / 2;
    buckle.position.set(0, -0.45, 0.3);
    vest.add(buckle);
    this.group.add(vest);
  }
}
